"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacingLabelsToJSON = exports.PlacingLabelsFromJSONTyped = exports.PlacingLabelsFromJSON = void 0;
function PlacingLabelsFromJSON(json) {
    return PlacingLabelsFromJSONTyped(json, false);
}
exports.PlacingLabelsFromJSON = PlacingLabelsFromJSON;
function PlacingLabelsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'position': json['position'],
        'name': json['name'],
        'toPar': json['toPar'],
        'thru': json['thru'],
        'score': json['score'],
    };
}
exports.PlacingLabelsFromJSONTyped = PlacingLabelsFromJSONTyped;
function PlacingLabelsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'position': value.position,
        'name': value.name,
        'toPar': value.toPar,
        'thru': value.thru,
        'score': value.score,
    };
}
exports.PlacingLabelsToJSON = PlacingLabelsToJSON;
